import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useSelector, useDispatch, useStore } from '@grandvisionhq/state';
import { useCheckoutSettings } from '../../../../context/CheckoutSettings/context.js';
import '@swc/helpers';
import { selectShippingMethod, selectStore, selectServiceStore, selectPickupPoint } from '../../../actions.js';
import { getSelectedShippingMethod, getSelectedStore, getSelectedPickupPoint } from '../../../selectors.js';
import '@grandvisionhq/common';
import '@grandvisionhq/elements';
import '@grandvisionhq/icons';
import '@grandvisionhq/iris-ui';
import '@grandvisionhq/locations';
import '../containers/PickupPointsFinderContainer.js';
import '../containers/StoresFinderContainer.js';
import { ShippingMethodsListContainer } from '../containers/ShippingMethodsListContainer.js';
import { SelectedShippingMethodContainer } from '../containers/SelectedShippingMethodContainer.js';
import { useShippingMethodSelection } from '../hooks/use-shipping-method-selection.js';
import { useShippingMethodsList } from '../hooks/use-shipping-methods-list.js';
import { shippingMethodsSuccess, shippingMethodsFailed } from '../state/actions.js';

const ShippingMethods = ({ shippingMethodsAsides  })=>{
    const { shipping  } = useCheckoutSettings();
    const selectedShippingMethod1 = useSelector(getSelectedShippingMethod);
    const dispatch = useDispatch();
    const { cart  } = Context.useCart();
    const store1 = useStore();
    const selectedStore = useSelector(getSelectedStore);
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    /**
   *  Success handler for shippingMethodForCart query operation
   */ const onShippingMethodsLoadCompleted = React.useCallback((shippingMethodList)=>{
        const selectedShippingMethod = getSelectedShippingMethod(store1.getState());
        const isSelectedShippingMethodValid = shippingMethodList.find((method)=>{
            return (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) == method.key;
        });
        if ((selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method) && !isSelectedShippingMethodValid) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: true
                }
            }));
        } else if (cart && (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) !== (selectedShippingMethod === null || selectedShippingMethod === void 0 ? void 0 : selectedShippingMethod.method)) {
            if (cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key) {
                dispatch(selectShippingMethod({
                    shippingMethod: {
                        method: cart === null || cart === void 0 ? void 0 : cart.shippingMethod.key,
                        isValid: true,
                        isTouched: false
                    }
                }));
            } else {
                // Cart has no shipping method information, try to use the actual default value
                // This happens when a feature toggle in cart-service (ADD_SHIPPING_METHOD_TO_CART) is disabled
                const defaultShippingMethod = shippingMethodList.find((method)=>method.isDefault
                );
                if (defaultShippingMethod) {
                    dispatch(selectShippingMethod({
                        shippingMethod: {
                            method: defaultShippingMethod.key,
                            isValid: true,
                            isTouched: false
                        }
                    }));
                }
            }
        }
        dispatch(shippingMethodsSuccess({
            result: shippingMethodList
        }));
    }, [
        cart,
        dispatch,
        store1
    ]);
    const onShippingMethodLoadError = React.useCallback(()=>{
        dispatch(shippingMethodsFailed({
            message: 'Unable to load shipping methods'
        }));
    }, [
        dispatch
    ]);
    const { shippingMethodList: shippingMethodList1 , reloadShippingMethods , isLoading , error  } = useShippingMethodsList(onShippingMethodsLoadCompleted, onShippingMethodLoadError);
    const onError = React.useCallback(()=>{
        reloadShippingMethods();
    }, [
        reloadShippingMethods
    ]);
    const { handleOnShippingMethodSelected  } = useShippingMethodSelection({
        shippingMethodList: shippingMethodList1,
        onError
    });
    const onStoreSelect = (store)=>{
        const serviceStore = {
            code: store.code,
            name: store.name,
            streetName: store.streetName,
            streetNumber: store.streetNumber,
            town: store.town
        };
        dispatch(selectStore({
            store
        }));
        dispatch(selectServiceStore({
            serviceStore
        }));
    };
    const onPickupPointSelect = (pickupPoint)=>{
        if (!pickupPoint) {
            return;
        }
        dispatch(selectPickupPoint({
            pickupPoint
        }));
    };
    // If settings require explicit shipping method selection, invalidate and deselect shipping method on load
    React.useEffect(()=>{
        if (!(selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.isTouched) && (selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.isValid) && (shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod)) {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: false
                }
            }));
        }
    }, [
        dispatch,
        selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.isTouched,
        selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.isValid,
        shipping === null || shipping === void 0 ? void 0 : shipping.explicitShippingMethod, 
    ]);
    if (!shippingMethodList1) return null;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-shipping-methods"
    }, /*#__PURE__*/ React.createElement(ShippingMethodsListContainer, {
        asides: shippingMethodsAsides,
        selectedShippingMethod: selectedShippingMethod1,
        shippingMethodList: shippingMethodList1,
        handleOnShippingMethodSelected: handleOnShippingMethodSelected,
        isLoading: isLoading,
        error: error
    })), /*#__PURE__*/ React.createElement(SelectedShippingMethodContainer, {
        selectedShippingMethod: selectedShippingMethod1 === null || selectedShippingMethod1 === void 0 ? void 0 : selectedShippingMethod1.method,
        onStoreSelect: onStoreSelect,
        selectedStore: selectedStore,
        onPickupPointSelect: onPickupPointSelect,
        selectedPickupPoint: selectedPickupPoint
    }));
};

export { ShippingMethods };
//# sourceMappingURL=ShippingMethods.js.map
